import React from 'react';
// Import contexts
import { useFormContext } from 'react-hook-form';
// Import components
import DateInput from 'components/shared/FormElements/Date/Date';
import Input from 'components/shared/FormElements/Input/Input';
import Radios from 'components/shared/FormElements/Radios/Radios';
// Import helper functions
import dateValidationHelpers from 'components/shared/FormElements/Date/dateValidationHelpers';

const DOB = () => {
  const { register } = useFormContext(); // Custom hook for handling validation (errors etc)

  const { dateRegex, futureDate } = dateValidationHelpers;

  const dateValidation = register({
    required: 'Enter a Date of event',
    pattern: {
      value: dateRegex,
      message: 'Enter Date of event in the correct format, for example 18 03 2020',
    },
    validate: {
      futureDate: (value) => futureDate(value, 10) || 'Date of event must be in the future',
    },
  });

  const radioButtons = [
    { text: '30 Minutes', value: '30 Minutes' },
    { text: '45 Minutes', value: '45 Minutes' },
    { text: '60 Minutes', value: '60 Minutes' },
    { text: 'Other', value: 'Other' },
  ];

  // Logic used to validate fields
  const fieldValidation = (name) => {
    return register({ required: `${name} is required` });
  };

  return (
    <>
      <DateInput
        name="DateOfEvent"
        label="Date of event"
        autoCompletPrefix="eday-"
        fieldValidation={dateValidation}
      />
      <Input
        className="wmcads-col-1 wmcads-col-sm-3-4 wmcads-col-md-1-2"
        name="EventStartTime"
        label="Event start time"
        type="time"
        fieldValidation={fieldValidation('Event start time')}
      />
      <Radios
        name="EventDuration"
        radios={radioButtons}
        fieldValidation={register({
          required: `Please select one option to proceed`,
        })}
      />
    </>
  );
};

export default DOB;
